<script setup>
import MiniStatisticsCard from "@/examples/Cards/MiniStatisticsCard.vue";
import Accounts from "../components/Accounts.vue";
import Cards from "../components/Cards.vue";
import Transactions from "../components/Transactions.vue";
import {computed, onBeforeMount, onMounted, onUnmounted, onUpdated} from "vue";
import router from "../router";
import cookie from '../assets/js/cookies.js';
import validSession from "../assets/js/valid-session.js";
import {useStore} from "vuex";
import axios from "axios";
import SkeletonLoad from "../components/SkeletonLoad.vue";
import {toast} from 'vue3-toastify';
import DonutChart from "../components/DonutChart.vue";
import Masonry from "masonry-layout";
import BarChart from "../components/BarChart.vue";
import ObjetivesRowDashboard from "../components/ObjetivesRowDashboard.vue";
import {activateDarkMode, deactivateDarkMode} from "@/assets/js/dark-mode";
import emitter from "../assets/js/eventBus.js";
import bootstrap from "bootstrap/dist/js/bootstrap";
import { useI18n } from "vue-i18n";

const store = useStore();
const loaded_itens = [];

const setSidebarType = (type) => store.commit("sidebarType", type);

const darkMode = computed(() => store.state.darkMode);

const { t } = useI18n();

let meses = [
        t('message.global.month.jan'),
        t('message.global.month.feb'),
        t('message.global.month.mar'),
        t('message.global.month.apr'),
        t('message.global.month.may'),
        t('message.global.month.jun'),
        t('message.global.month.jul'),
        t('message.global.month.aug'),
        t('message.global.month.sep'),
        t('message.global.month.oct'),
        t('message.global.month.nov'),
        t('message.global.month.dec')
    ];

onBeforeMount(() => {

  validSession.isLogged();

  let session = cookie.get('user_agive_session');

  let day = new Date().getDate();
  let month = new Date().getMonth() + 1;
  let year = new Date().getFullYear();

  store.state.current_date = year+ '-' + (month < 10 ? '0'+month : month) + '-' + (day < 10 ? '0'+ day : day);

  store.state.selectedYear = new Date().getFullYear();
  store.state.selectedMonth = {
      index: new Date().getMonth(),
      number: new Date().getMonth() + 1,
      display: meses[new Date().getMonth()]
  };

  store.state.loading_values = true;
  store.state.values = {
    balance: 0,
    in: 0,
    out: 0,
    cc: 0,
  }

  store.state.loading_accounts = true;
  store.state.accounts = [];

  store.state.loading_cards = true;
  store.state.cards = [];

  store.state.loading_objetives = true;
  store.state.objetives = [];

  store.state.loading_transactions = true;
  store.state.transactions_in = [];
  store.state.transactions_out = [];

  store.state.loading_categoriesChart = true;
  store.state.categoriesChartData = [];
  
  store.state.categoriesChart = {
    chartData: {
          labels: ['VueJs', 'EmberJs', 'ReactJs', 'AngularJs'],
          datasets: [
            {
              backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#DD1B16'],
              data: [40, 20, 80, 10]
            }
          ]
        },
        chartOptions: {
          responsive: true,
          maintainAspectRatio: false
        }
  }

  store.state.InOutChart = {
    chartData: {
          labels: [ 'January' ],
          datasets: [ 
            { 
              label: t('message.global.revenue'),
              backgroundColor: '#2dce89',
              data: [40] 
            },
            { 
              label: t('message.global.expense'),
              backgroundColor: '#f5365c',
              data: [100] 
            }
          ]
        },
        chartOptions: {
          responsive: true,
        }
  }

  store.state.InOutAnnualChartYear = new Date().getFullYear();
  store.state.loading_InOutAnnualChart = true;
  store.state.InOutAnnulChart = {
    chartData: {
          labels: [ 'January' ],
          datasets: [ 
            { 
              label: t('message.global.revenue'),
              backgroundColor: '#2dce89',
              data: [40] 
            },
            { 
              label: t('message.global.expense'),
              backgroundColor: '#f5365c',
              data: [100] 
            }
          ]
        },
        chartOptions: {
          responsive: true,
        }
  }

  store.state.welcomeMessage =  '';

  if(session !== null){
    getValues();
    getAccounts();
    getCards();
    getTransaction();
    getCategories();
    getObjetives();
    getUserData();
    getValuesAnnual();
  }
    
})

const reload_data = () => {
  getValues();
  getAccounts();
  getCards();
  getTransaction();
  getCategories();
  getObjetives();
  getUserData();
  getValuesAnnual();
}; 

onMounted(() => {

  emitter.on('load-data', reload_data);

  let session = cookie.get('user_agive_session');
  let notification = cookie.get('user_agive_notification');

  if(session == null){
    router.push({name: 'Login'});
  }

  if(notification != null){
    alert(notification);
  }

  if(isMobile()){

    let message = {
            'action': 'getToken',
            'session': session
          };
    
    if(window.ReactNativeWebView){
      window.ReactNativeWebView.postMessage(JSON.stringify(message));
    }

  }

});

onUpdated(() => {
  if(loaded_itens.length === 7){
        if(!isMobile()){

          var row = document.querySelector(".mansory-row");
          new Masonry(row, {
            // options
            percentPosition: true,
            horizontalOrder: true
          });

      }
    }
});

onUnmounted(() => {
  emitter.off('load-data', reload_data);
});

const getValues = async () => {

  let period = store.state.selectedYear + '-' + (store.state.selectedMonth.number < 10 ? '0' + store.state.selectedMonth.number : store.state.selectedMonth.number);

  axios.get('dashboard/values?period='+period)
    .then(res => {
        
        if(res.status === 200){

            store.state.values = {
              balance: res.data.balance ? res.data.balance : 0,
              balance_future: res.data.balance_future ? res.data.balance_future : 0,
              in: res.data.in ? res.data.in : 0,
              in_payed: res.data.in_payed ? res.data.in_payed : 0,
              out: res.data.out ? res.data.out : 0,
              out_payed: res.data.out_payed ? res.data.out_payed : 0,
              cc: res.data.cc ? res.data.cc : 0,
              cc_payed: res.data.cc_payed ? res.data.cc_payed : 0,
            }

            store.state.InOutChart = {
              chartData: {
                    labels: [ meses[new Date().getMonth()] ],
                    datasets: [ 
                      { 
                        label: t('message.global.revenue'),
                        backgroundColor: '#2dce89',
                        borderRadius: 10,
                        data: [res.data.in ? res.data.in : 0] 
                      },
                      { 
                        label: t('message.global.expense'),
                        backgroundColor: '#f5365c',
                        borderRadius: 10,
                        data: [res.data.out ? res.data.out : 0] 
                      }
                    ]
              },
              chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                plugins:{
                  tooltip: {
                    callbacks: {
                      label: function(context) {
                        
                          let label = context.dataset.label || '';

                          if (label) {
                              label += ': ';
                          }
                          if (context.raw !== null) {
                              label += new Intl.NumberFormat(t('message.global.date_language'), { style: 'currency', currency: 'BRL' }).format(context.raw);
                          }
                          return label;
                      }
                    }
                  },
                  legend: {
                        display: true,
                        maxWidth: 150,
                        labels: {
                            color: darkMode.value ? 'white' : 'black',
                            usePointStyle: true
                        },
                        fullSize: true
                    },
                  datalabels: {
                    formatter: function(value) {
                      return new Intl.NumberFormat(t('message.global.date_language'), { style: 'currency', currency: 'BRL' }).format(parseFloat(value))
                    },
                    backgroundColor: '#0000001A',
                    borderRadius: 3,
                    color: 'white',
                  }
                }
              }
            }

            store.state.loading_values = false;

            loaded_itens.push('Values');

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const getAccounts = async () => {

  axios.get('/dashboard/accounts')
  .then(res => {
      
      if(res.status === 200){

          store.state.accounts = res.data;
          store.state.loading_accounts = false;

          loaded_itens.push('Accounts');

      }
      
  })
  .catch(err => {
      console.error(err); 
  })

}

const getCards = async () => {

  let period = store.state.selectedYear + '-' + (store.state.selectedMonth.number < 10 ? '0' + store.state.selectedMonth.number : store.state.selectedMonth.number);

  axios.get('/dashboard/cards?period='+period)
  .then(res => {
      
      if(res.status === 200){

          store.state.cards = res.data;
          store.state.loading_cards = false;

          loaded_itens.push('Cards');

      }
      
  })
  .catch(err => {
      console.error(err); 
  })

}

const getTransaction = async () => {

  //store.state.loading_transactions = true;

  axios.get('dashboard/transactions')
    .then(res => {
        
        if(res.status === 200){

            store.state.transactions_in = res.data.in;
            store.state.transactions_out = res.data.out;

            store.state.loading_transactions = false;

            loaded_itens.push('Transactions');

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const payTransation = (transaction) => {

  if(transaction.type !== 'transferência'){

    emitter.emit('set-type', { data: transaction.type });

    store.state.transaction_value.value = formatMoney(transaction.amount);

    store.state.transation = {
      type: transaction.type,
      description: transaction.description,
      amount: formatMoney(transaction.amount),
      date: transaction.date,
      account: transaction.account_id > 0 ? transaction.account_id+'-bank': transaction.card_id+'-card',
      account_name: transaction.account_name,
      account_destiny: transaction.account_destiny_id > 0 ? transaction.account_destiny_id+'-bank': '',
      account_destiny_name: transaction.account_destiny_name,
      category: transaction.category_id,
      category_name: transaction.category_name,
      category_icon: transaction.category_icon,
      category_color: transaction.category_color,
      recurrence_checked: false,
      recurrence: transaction.recurrence,
      recurrence_period: '',
      initial_installment: 1,
      current_installment: transaction.current_installment,
      end_installment: transaction.end_installment,
      payed: 'Paid',
      id: transaction.id,
      transaction_id: transaction.transaction_id,
      invoice_id: transaction.invoice_id,
      card_id: transaction.card_id,
      howUpdate: 'just_this',
      amount_paid: transaction.amount_paid,
      ammount_unpaid: transaction.ammount_unpaid,
      observation: transaction.observation
    }

    openModal('payTransaction');

  }
  else{

    let url = '/transactions/pay/'+transaction.id;

    let data = new FormData();

    data.append('status', transaction.status === 'Paid' ? 'Unpaid' : 'Paid');

    axios.post(url, data)
        .then(res => {

          if(!res.data.error){

            toast('Transação atualizada com sucesso!', {
              autoClose: 1000,
              theme: "auto",
              type: "success",
              transition: "slide"
            });

            getTransaction(true, transaction.id);
            clearFields();

          }

        })
        .catch(err => {
          console.error(err);
        })

  }


}

const openModal = (id) => {

  let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById(id));

  modal.show();

}

const formatMoney = (v) => {
  let total = parseFloat(v);

  return total.toLocaleString("pt-br", {
    style: "currency",
    currency: "BRL",
  });
}

const getCategories = async () => {

  let period = store.state.selectedYear + '-' + (store.state.selectedMonth.number < 10 ? '0' + store.state.selectedMonth.number : store.state.selectedMonth.number);

  axios.get('dashboard/categories?period='+period)
  .then(res => {
      
      if(res.status === 200){

        let chart_lables = [];
        let chart_values = [];
        let chart_colors = [];
        let total = 0;
        
        res.data.forEach((value) => {

          chart_lables.push(value.name);
          chart_colors.push(value.color);
          chart_values.push(value.amount);

          total = total + parseFloat(value.amount);

        });

        store.state.categoriesChart = {
          chartData: {
                labels: chart_lables,
                datasets: [
                  {
                    data: chart_values
                  }
                ]
              },
              chartOptions: {
                responsive: true,
                backgroundColor: chart_colors,
                maintainAspectRatio: true,
                plugins: {
                    title: {
                        display: false,
                        text: t('message.home.expenses_by_category')
                    },
                    legend: {
                        display: true,
                        position: 'bottom',
                        maxWidth: 150,
                        labels: {
                            color: darkMode.value ? 'white' : 'black',
                            usePointStyle: true
                        },
                        fullSize: true
                    },
                    tooltip: {
                      callbacks: {
                        label: function(context) {
                          
                            let label = context.dataset.label || '';

                            if (label) {
                                label += ': ';
                            }
                            if (context.parsed.y !== null) {
                                label += new Intl.NumberFormat(t('message.global.date_language'), { style: 'currency', currency: 'BRL' }).format(context.parsed);
                            }
                            return label;
                        }
                      }
                    },
                    datalabels: {
                      display: true,
                      align: 'center',
                      backgroundColor: '#0000001A',
                      borderRadius: 3,
                      color: 'white',
                      position: 'outside',
                      hoverOffset: 4,
                      font: {
                        size: 12,
                      },
                      formatter: (value, ctx) => {
                        const total = ctx.chart.getDatasetMeta(0).total;
                        return (value * 100 / total).toFixed(2) + "%";
                      }
                    },                   
                    doughnutlabel: {
                      labels: [
                        {
                          text: new Intl.NumberFormat(t('message.global.date_language'), { style: 'currency', currency: 'BRL' }).format(parseFloat(total)),
                          font: {
                            size: 20,
                            weight: 'bold',
                          },
                          color: darkMode.value ? 'white' : 'black'
                        },
                        {
                          text: 'total',
                          color: darkMode.value ? 'white' : 'black'
                        },
                      ],
                    },                  
                }
              }
        }

        store.state.categoriesChartData = res.data;

        store.state.loading_categoriesChart = false;

        loaded_itens.push('CategoriesChart');

          //store.state.cards = res.data;
          //store.state.loading_cards = false;

      }
      
  })
  .catch(err => {
      console.error(err); 
  })

}

const getObjetives = async () => {

  axios.get('/dashboard/objetives')
  .then(res => {
      
      if(res.status === 200){

          store.state.objetives = res.data;
          store.state.loading_objetives = false;

          loaded_itens.push('Objetives');

      }
      
  })
  .catch(err => {
      console.error(err); 
  })

}

const isMobile = () => {
  
  // check if mobile device
  const isMobileDevice = window.navigator.userAgent
    .toLowerCase()
    .includes("mobi");

  const isIpadDevice = window.navigator.userAgent
    .toLowerCase()
    .includes("ipad");

  return isMobileDevice && !isIpadDevice;

}

const getUserData = async () => {

  axios.get('users/data')
  .then(res => {
      
      if(res.status === 200){

        cookie.add('user_agive_email', res.data.email, 86400);
        cookie.add('user_agive_name', res.data.name, 86400);

        if(res.data.darkmode === 'Yes'){

          store.state.darkMode = true;
          setSidebarType("bg-default");
          activateDarkMode();

        }
        else{

          store.state.darkMode = false;
          setSidebarType("bg-white");
          deactivateDarkMode();

        }

        store.state.welcomeMessage = res.data.name+'!';

      }
      
  })
  .catch(err => {
      console.error(err); 
  })

}

const getValuesAnnual = async () => {

  axios.get('dashboard/values-annual/'+store.state.InOutAnnualChartYear)
  .then(res => {

    let labels = [
      meses[0],
      meses[1],
      meses[2],
      meses[3],
      meses[4],
      meses[5],
      meses[6],
      meses[7],
      meses[8],
      meses[9],
      meses[10],
      meses[11],
    ];

    store.state.InOutAnnualChart = {
              chartData: {
                    labels: labels,
                    datasets: [ 
                      { 
                        label: t('message.global.revenue'),
                        backgroundColor: '#2dce89',
                        borderRadius: 10,
                        data: res.data.in 
                      },
                      { 
                        label: t('message.global.expense'),
                        backgroundColor: '#f5365c',
                        borderRadius: 10,
                        data: res.data.out 
                      }
                    ]
              },
              chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                barPercentage: 0.7,
                plugins:{
                  tooltip: {
                    callbacks: {
                      label: function(context) {
                        
                          let label = context.dataset.label || '';

                          if (label) {
                              label += ': ';
                          }
                          if (context.raw !== null) {
                              label += new Intl.NumberFormat(t('message.global.date_language'), { style: 'currency', currency: 'BRL' }).format(context.raw);
                          }
                          return label;
                      }
                    }
                  },
                  legend: {
                        display: true,
                        maxWidth: 150,
                        labels: {
                            color: darkMode.value ? 'white' : 'black',
                            usePointStyle: true
                        },
                        fullSize: true
                    },
                  datalabels: {
                    formatter: function(value) {
                      return new Intl.NumberFormat(t('message.global.date_language'), { style: 'currency', currency: 'BRL' }).format(parseFloat(value))
                    },
                    backgroundColor: '#0000001A',
                    borderRadius: 3,
                    color: 'black',
                    display: false
                  }
                }
              }
            }

    store.state.loading_InOutAnnualChart = false;

    loaded_itens.push('InOutAnnualChart');

  })
  .catch(err => {
    console.error(err); 
  })

}

const slideDate = (direction) => {

    if(direction === 'prev'){

        let prev_month = store.state.selectedMonth.index > 0 ? store.state.selectedMonth.index - 1 : 11;
        store.state.selectedYear = store.state.selectedMonth.index > 0 ? store.state.selectedYear : store.state.selectedYear - 1;
        store.state.selectedMonth = {
            index: prev_month,
            number: prev_month + 1,
            display: meses[prev_month]
        };

        getValues();
        getCategories();
        getCards();

    }
    else if(direction === 'next'){

        let next_month = store.state.selectedMonth.index < 11 ? store.state.selectedMonth.index + 1 : 0;
        store.state.selectedYear = store.state.selectedMonth.index < 11 ? store.state.selectedYear : store.state.selectedYear + 1;
        store.state.selectedMonth = {
            index: next_month,
            number: next_month + 1,
            display: meses[next_month]
        };

        getValues();
        getCategories();
        getCards();

    }
}

const clearFields = () => {

  store.state.transaction_value.value = 0

  store.state.transation = {
    type: '',
    description: '',
    amount: 0,
    date: store.state.current_date,
    account: '',
    account_name: '',
    account_destiny: '',
    account_destiny_name: '',
    category: '',
    category_name: '',
    category_icon: '',
    category_color: '',
    recurrence_checked: false,
    recurrence: '',
    recurrence_period: 'monthly',
    initial_installment: 1,
    current_installment: 1,
    end_installment: 1,
    payed: false,
    id: '',
    transaction_id: '',
    invoice_id: '',
    card_id: '',
    howUpdate: '',
    amount_paid: 0,
    ammount_unpaid: 0,
    observation: '',
    objetive: ''
  }

  store.state.suggestions = [];
}

</script>
<template>
  <div class="pb-4 container-fluid overflow-auto vh-100">
    <div class="row">
      <div class="col-12 col-lg-8 mb-3 mt-2">
        <h4 :class="darkMode ? 'darkmode text-white' : 'fc-azul-petroleo'">{{ $t('message.hello') }}, {{ store.state.welcomeMessage }}</h4>
      </div>
      <div class="col-12 bg-selector sticky-top" :class="darkMode ? 'darkmode text-white' : 'fc-azul-petroleo'">

        <div class="col-12 col-md-8 mx-auto mt-3 mt-lg-0 mb-3">
          <div class="row">
              <div class="col-2 col-lg-4 text-end">
                  <a class="cursor-pointer" @click="slideDate('prev')">
                      <i class="fal fa-chevron-left me-0 me-lg-5"></i>
                  </a>
              </div>
              <div class="col-8 col-lg-4 mx-auto text-center">
                  <span>
                      {{ store.state.selectedMonth.display }} {{ store.state.selectedYear }}
                  </span>
              </div>
              <div class="col-2 col-lg-4 text-start">
                  <a class="cursor-pointer" @click="slideDate('next')">
                      <i class="fal fa-chevron-right ms-0 ms-lg-5"></i>
                  </a>
              </div>
          </div>
          
            
        </div>

        <hr>
      </div>
      
      <div class="col-lg-12">

        <div class="row">
          <div id="mini-card-contas" class="col-xxl-3 col-lg-6 col-md-6 col-12">
            <mini-statistics-card
              :title="{
                text: t('message.global.bank_account'),
                color: ''
              }"
              :value="{
                text: store.state.values.balance,
                color: ''
              }"
              :future_value="{
                text: store.state.values.balance_future,
                color: ''
              }"
              description=""
              :icon="{
                component: 'fal fa-wallet fc-azul-petroleo',
                background: 'bg-contas',
                shape: 'rounded-5',
              }"
              :loading="store.state.loading_values"
              :rowReverse="true"
            />
          </div>
          <div id="mini-card-receitas" class="col-xxl-3 col-lg-6 col-md-6 col-12">
            <mini-statistics-card
              :title="{
                text: t('message.global.revenue'),
                color: ''
              }"
              :value="{
                text: store.state.values.in_payed,
                color: ''
              }"
              :future_value="{
                text: store.state.values.in,
                color: ''
              }"
              description=""
              :icon="{
                component: 'fal fa-plus fc-azul-petroleo',
                background: 'bg-success',
                shape: 'rounded-5',
              }"
              :loading="store.state.loading_values"
              :rowReverse="true"
            />
          </div>
          <div id="mini-card-despesas" class="col-xxl-3 col-lg-6 col-md-6 col-12">
            <mini-statistics-card
              :title="{
                text: t('message.global.expense'),
                color: ''
              }"
              :value="{
                text: store.state.values.out_payed,
                color: ''
              }"
              :future_value="{
                text: store.state.values.out,
                color: ''
              }"
              description=""
              :icon="{
                component: 'fal fa-minus text-white',
                background: 'bg-danger',
                shape: 'rounded-5',
              }"
              :loading="store.state.loading_values"
              :rowReverse="true"
            />
          </div>
          <div id="mini-card-cartoes" class="col-xxl-3 col-lg-6 col-md-6 col-12">

            <mini-statistics-card
              :title="{
                text: t('message.global.card'),
                color: ''
              }"
              :value="{
                text: store.state.values.cc_payed,
                color: ''
              }"
              :future_value="{
                text: store.state.values.cc,
                color: ''
              }"
              description=""
              :icon="{
                component: 'fal fa-credit-card fc-azul-petroleo',
                background: 'bg-cartoes',
                shape: 'rounded-5',
              }"
              :loading="store.state.loading_values"
              :rowReverse="true"
            />
            
          </div>
        </div>

        <div class="row mansory-row">

          <!--Linha minhas contas-->
          <div id="minhas-contas" class="col-xxl-4 col-lg-6 col-md-6 order-lg-0">

            <div class="card shadow">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between">
                  <h6 class="mb-md-3 mb-n1 mt-n1 mt-md-0 text-white">{{$t('message.home.my_accounts')}}</h6>
                </div>
              </div>
              <div v-if="store.state.loading_accounts" class="col-12">
                <div class="col-12">

                  <div class="row align-items-center row-accounts">

                      <div class="col-2 col-lg-1 ms-3">
                        <SkeletonLoad
                            :width="'45px'"
                            :height="'45px'"
                            :class="'rounded-5'"
                        />
                      </div>
                      <div class="col-3 col-lg-4">
                        <SkeletonLoad
                            :width="'90px'"
                            :height="'25px'"
                            :class="'ms-4'"
                        />
                      </div>
                      <div class="col-5 col-lg-6 text-end">
                        <SkeletonLoad
                            :width="'90px'"
                            :height="'25px'"
                            :class="'float-end'"
                        />
                      </div>

                  </div>

                </div>
              </div>
              <div v-else class="col-12">
                <Accounts
                  v-for="(account, index) in store.state.accounts" :key="index"
                  :bank="account.name"
                  :balance="account.balance"
                  :id="account.id"
                  :icon="account.icon"
                  :darkmode="darkMode"
                />
              </div>
            </div>

          </div>

          <!--Linha Cartões-->
          <div id="meus-cartoes" class="col-md-6 col-lg-6 col-xxl-4 mt-3 mt-md-0 mt-lg-0 mb-3 mb-lg-0 order-lg-2 order-xxl-3">

            <div class="card shadow">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between">
                  <h6 class="mb-md-3 mb-n1 mt-n1 mt-md-0 text-white">{{$t('message.home.my_credit_cards')}}</h6>
                </div>
              </div>
              <div v-if="store.state.loading_cards" class="col-12">
                <div class="row align-items-center row-cards">

                  <div class="col-5 align-content-between d-flex align-items-center">
                      
                      <div>
                        <SkeletonLoad
                            :width="'90px'"
                            :height="'20px'"
                            :class="'ms-4 mt-n1 mb-n1'"
                        />
                                                      
                      </div>
                  </div>
                  <div class="col-5 text-end">
                    <SkeletonLoad
                        :width="'90px'"
                        :height="'20px'"
                        :class="'ms-3'"
                    />
                  </div>
                  <div class="col-2 text-end">

                  </div>

                  

                </div>
              </div>
              <div v-else class="col-12 mt-3">

                <Cards
                v-for="(card, index) in store.state.cards" :key="index"
                :name="card.name"
                :limit="card.limit"
                :value="card.current_invoice.current_amount"
                :before_value="card.current_invoice.before_amount"
                :due_date="card.current_invoice.due_date"
                :icon="card.icon"
                :id="card.current_invoice.id"
                :status="card.current_invoice.status"
                :sum="card.sum[0].current_amount"
                :fixes="card.future_fixed[0].amount ? card.future_fixed[0].amount : 0"
                :installments="card.future_Installments ? card.future_Installments[0].amount : 0"
                :darkmode="darkMode"
                />
                
              </div>
              <div class="col-12 text-center" v-if="store.state.cards.length === 0 && !store.state.loading_cards">
                    <p>{{ t('message.global.zero_cards') }}</p>
                  </div>
            </div>

          </div>

          <!--Linha Objetivos-->
          <div id="meus-objetivos" class="col-md-6 col-lg-6 col-xxl-4 mt-md-3 mt-lg-3 mt-xxl-0 mb-3 mb-md-0 mb-lg-0 order-lg-2 order-xxl-3">

            <div class="card shadow">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between">
                  <h6 class="mb-md-3 mb-n1 mt-n1 mt-md-0 text-white">{{$t('message.home.my_objetives')}}</h6>
                </div>
              </div>
              <div v-if="store.state.loading_objetives" class="col-12">
                <div class="row align-items-center row-cards">

                  <div class="col-5 align-content-between d-flex align-items-center">
                      
                      <div>
                        <SkeletonLoad
                            :width="'90px'"
                            :height="'20px'"
                            :class="'ms-4 mt-n1 mb-n1'"
                        />
                                                      
                      </div>
                  </div>
                  <div class="col-5 text-end">
                    <SkeletonLoad
                        :width="'90px'"
                        :height="'20px'"
                        :class="'ms-3'"
                    />
                  </div>
                  <div class="col-2 text-end">

                  </div>

                  

                </div>
              </div>
              <div v-else class="col-12 mt-3">

                <ObjetivesRowDashboard
                v-for="(objetive, index) in store.state.objetives" :key="index"
                :objetive="objetive"
                :darkmode="darkMode"
                />
                
              </div>
              <div class="col-12 text-center" v-if="store.state.objetives.length === 0 && !store.state.loading_objetives">
                    <p>{{$t('message.global.zero_objetives')}}</p>
                  </div>
            </div>

          </div>

          <!-- Lista de despesas e receitas -->
          <div id="minhas-despesas-receitas" class="col-12 col-md-6 col-lg-6 col-xxl-4 mt-lg-3 order-lg-3 order-xxl-2">

            <div class="card shadow">

              <div class="pt-3 pb-0 card-header">

                <div class="d-flex justify-content-between">
                  <h6 class="mb-3 mt-n1 mt-md-0 text-white">{{$t('message.home.pending_transactions')}}</h6>
                </div>

                <ul class="nav nav-tabs no-border mb-n3 mb-md-0" id="transactions-tab" role="tablist">
                  <li class="nav-item" role="presentation">
                      <button class="nav-link active despesa" :class="darkMode ? 'darkmode' : ''" id="out-transactions-tab" data-bs-toggle="tab" data-bs-target="#out-transactions" type="button" role="tab" aria-controls="out-transactions" aria-selected="true">{{$t('message.global.expense', 2)}}</button>
                  </li>
                  <li class="nav-item" role="presentation">
                      <button class="nav-link" :class="darkMode ? 'darkmode' : ''" id="in-transactions-tab" data-bs-toggle="tab" data-bs-target="#in-transactions" type="button" role="tab" aria-controls="in-transactions" aria-selected="false">{{$t('message.global.revenue', 2)}}</button>
                  </li>
                </ul>

              </div>

              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="out-transactions" role="tabpanel" aria-labelledby="out-transactions-tab">

                  <div v-if="store.state.loading_transactions" class="col-12">

                  <div class="row align-items-center row-transactions">

                      <div class="col-2 col-lg-1 ms-3 text-center">
                        <SkeletonLoad
                            :width="'45px'"
                            :height="'45px'"
                        />
                      </div>
                      <div class="col-7 col-lg-8">
                          <div class="row align-items-center">
                              <div class="col-12 col-lg-6">
                                <SkeletonLoad
                                    :width="'80px'"
                                    :height="'20px'"
                                    :class="'ms-2'"
                                />
                                <SkeletonLoad
                                    :width="'120px'"
                                    :height="'20px'"
                                    :class="'ms-2 mt-1'"
                                />
                              </div>
                              <div class="col-12 col-lg-6 text-lg-center">
                                <SkeletonLoad
                                  :width="'120px'"
                                  :height="'20px'"
                                />
                              </div>
                          </div>
                      </div>
                      
                      <div class="col-2 text-end">
                          
                      </div>
                      
                      

                  </div>

                  </div>

                  <div class="col-12 text-center mt-4" v-if="store.state.transactions_out.length === 0 && !store.state.loading_transactions">
                    <p>{{$t('message.global.zero_transactions')}}</p>
                  </div>

                  <div v-if="!store.state.loading_transactions && store.state.transactions_out.length > 0" class="contas mb-3">
                    <transactions
                      v-for="(btp, index) in store.state.transactions_out" :key="index"
                      :transaction = btp
                      @pay="payTransation"
                      :darkmode="darkMode"
                    />
                  </div>

                </div>
                <div class="tab-pane fade" id="in-transactions" role="tabpanel" aria-labelledby="in-transactions-tab">

                  <div v-if="store.state.loading_transactions" class="col-12">

                      <div class="row align-items-center row-transactions">

                          <div class="col-2 col-lg-1 ms-3 text-center">
                            <SkeletonLoad
                                :width="'45px'"
                                :height="'45px'"
                            />
                          </div>
                          <div class="col-7 col-lg-8">
                              <div class="row align-items-center">
                                  <div class="col-12 col-lg-6">
                                    <SkeletonLoad
                                        :width="'80px'"
                                        :height="'20px'"
                                        :class="'ms-2'"
                                    />
                                    <SkeletonLoad
                                        :width="'120px'"
                                        :height="'20px'"
                                        :class="'ms-2 mt-1'"
                                    />
                                  </div>
                                  <div class="col-12 col-lg-6 text-lg-center">
                                    <SkeletonLoad
                                      :width="'120px'"
                                      :height="'20px'"
                                    />
                                  </div>
                              </div>
                          </div>
                          
                          <div class="col-2 text-end">
                              
                          </div>
                          
                          

                      </div>

                    </div>

                    <div class="col-12 text-center mt-4" v-if="store.state.transactions_in.length === 0 && !store.state.loading_transactions">
                      <p>{{$t('message.global.zero_transactions')}}</p>
                    </div>

                    <div v-if="!store.state.loading_transactions && store.state.transactions_in.length > 0" class="contas mb-3">
                      <transactions
                        v-for="(btr, index) in store.state.transactions_in" :key="index"
                        :transaction = btr
                        @pay="payTransation"
                        :darkmode="darkMode"
                      />
                    </div>

                </div>
              </div>

            </div>

          </div>

          <!-- Gráfico de despesas -->
          <div id="despesa-por-categoria" class="col-12 col-md-6 col-lg-6 col-xxl-4 mt-3 mb-3 order-lg-1">

            <div class="card shadow">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between">
                  <h6 class="mb-md-3 mb-n1 mt-n1 mt-md-0 text-white">{{$t('message.home.expenses_by_category')}}</h6>
                </div>
              </div>
              <div class="col-12">

                <div class="row">
                  <div class="col-lg-9 col-xxl-11 mb-3 mt-3 mx-auto">

                    <DonutChart 
                      v-if="store.state.categoriesChartData.length > 0 && !store.state.loading_categoriesChart" 
                      :chartData="store.state.categoriesChart.chartData" 
                      :chartOptions="store.state.categoriesChart.chartOptions"
                    ></DonutChart>

                    <SkeletonLoad v-if="store.state.loading_categoriesChart"
                        :width="'250px'"
                        :height="'250px'"
                        :class="'rounded-5 mx-auto mb-4'"
                    />

                  </div>
                </div>

              </div>
            </div>

          </div>
          
          <!-- Gráfico de Receitas x Despesas -->
          <div id="receitas-despesas" class="col-12 col-md-6 col-lg-6 col-xxl-4 mt-md-3 mt-lg-3 mb-3 order-lg-1">

            <div class="card shadow">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between">
                  <h6 class="mb-md-3 mb-n1 mt-n1 mt-md-0 text-white">{{$t('message.global.revenue', 2)}} x {{$t('message.global.expense', 2)}}</h6>
                </div>
              </div>
              <div class="col-12">

                <div class="row">
                  <div class="col-11 mt-3 mb-3 mx-auto" style="min-height: 250px">

                    <BarChart 
                      v-if="!store.state.loading_values" 
                      :chartData="store.state.InOutChart.chartData" 
                      :chartOptions="store.state.InOutChart.chartOptions"
                      ></BarChart>

                    <SkeletonLoad v-if="store.state.loading_values"
                        :width="'250px'"
                        :height="'250px'"
                        :class="'rounded-5 mx-auto mb-4'"
                    />

                  </div>
                </div>

              </div>
            </div>

          </div>

          <!-- Gráfico de Receitas x Despesas Anual -->
          <div id="receitas-despesas-anual" class="col-12 mt-lg-3 mb-5 mb-xl-5 order-lg-1">

            <div class="card mb-5 mb-md-3 mb-lg-0">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-8 col-lg-10">
                        <h6 class="mb-md-3 mb-n1 mt-md-0 text-white">{{$t('message.global.revenue', 2)}} x {{$t('message.global.expense', 2)}} - Anual</h6>
                      </div>
                      <div class="col-4 col-lg-2">
                        <select class="form-control form-control-sm" 
                          v-model="store.state.InOutAnnualChartYear"
                          @change="getValuesAnnual()"
                          v-bind:class="{
                                            'darkmode': darkMode,
                                        }"
                        >
                          <option v-for="n in 50" :key="n"
                                              :value="n + 2023"
                                          >
                                              {{n + 2023}}
                                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12">

                <div class="row">
                  <div class="col-11 mt-3 mb-3 mx-auto" style="min-height: 400px">

                    <BarChart 
                      v-if="!store.state.loading_InOutAnnualChart" 
                      :chartData="store.state.InOutAnnualChart.chartData" 
                      :chartOptions="store.state.InOutAnnualChart.chartOptions"
                      ></BarChart>

                    <SkeletonLoad v-if="store.state.loading_InOutAnnualChart"
                        :width="'250px'"
                        :height="'250px'"
                        :class="'mx-auto mb-4'"
                    />

                  </div>
                </div>

              </div>
            </div>

          </div>           

        </div>

      </div>
    </div>
  </div>

</template>

<style>
    .contas{
        max-height: 500px;
        overflow-x: hidden;
        overflow-y: auto;
    }

    #transactions-tab .nav-link.active{
        border-bottom: 2px solid #20c997 !important;
        border-top: none !important;
        border-left: none !important;
        border-right: none !important;
    }

    #transactions-tab .nav-link.active.despesa{
      border-bottom: 2px solid #f5365c !important;
    }

    #transactions-tab .nav-link.active.darkmode{
        border-bottom: 2px solid #20c997 !important;
        border-top: none !important;
        border-left: none !important;
        border-right: none !important;
        background-color: rgba(255, 255, 255, 0.13);
    }

    #transactions-tab .nav-link.active.despesa.darkmode{
      border-bottom: 2px solid #f5365c !important;
      background-color: rgba(255, 255, 255, 0.13);
    }
    
    #transactions-tab .nav-link{
        border: none !important;
        color:#fff;
        width: 100%;
    }

    #transactions-tab .nav-link.darkmode{
        border: none !important;
        color:#fff;
        width: 100%;
    }

    #transactions-tab .nav-item{
      width:50%;
    }

    .bg-body{
      background-color: #fdfd96 !important;
    }

    .bg-contas{
      background-color: #B3E5FC;
    }

    .bg-receitas, .btn-receita{
      background-color: #77dd77 !important;
    }

    .bg-despesas, .btn-despesa{
      background-color: #ff6961 !important;
    }

    .bg-cartoes{
      background-color: #84b6f4;
    }

    .border-receita{
      border-color: #77dd77 !important;
    }

    .border-despesa{
      border-color: #ff6961 !important;
    }

    .btn-receita{
      background-color: #77dd77 !important;
      color: #0c2b3a !important;
    }

    .btn-despesa{
      background-color: #ff6961 !important;
      color: #fff !important;
    }

    .rounded-5{
      border-radius: 0.75rem;
    }

    .bg-selector{
      background-color: #f1ebde;
    }

    .bg-selector.darkmode{
      background-color: #121212;
    }
    
</style>
